import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'concatName' })
export class ConcatNamePipe implements PipeTransform {
  transform(
    value: string,
    salutation: string,
    firstname: string,
    middlename: string
  ): string {
    let fullname = '';
    if (salutation) {
      fullname = salutation + ' ';
    }
    if (value) {
      fullname += value;
    }
    if (firstname) {
      fullname += ', ' + firstname;
    }
    if (middlename) {
      fullname += ' ' + middlename;
    }
    return fullname;
  }
}
